import ModalsManager from './ModalsManager';
export default ModalsManager;
